export const ModalDeactivateClient = ({
  clientRecurringBillings,
  clientWorkOrders,
  clientProjects,
  btnCancel,
}: any) => {
  let projectsToShow = clientProjects.filter((p) => p.active);
  let workOrdersToShow = clientWorkOrders.filter(
    (wo) => wo.closedDate === null
  );
  let recurringToShow = clientRecurringBillings.filter((rb) => rb.active);

  return (
    <>
      <div className="d-flex justify-content-end p-2">
        <div
          className="close-label"
          role="button"
          tabIndex={0}
          onClick={btnCancel}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              btnCancel(e);
            }
          }}
        >
          Close
        </div>
      </div>
      <div
        className="image-container mx-5 my-2"
        style={{
          maxHeight: "700px",
          overflowY: "auto",
        }}
      >
        <h3>
          This Client cannot be Deactivated because the following are assigned
          to it:
        </h3>
        {projectsToShow.length > 0 && (
          <ul>
            {projectsToShow.map((p) => (
              <li key={p.id} style={{ listStyle: "none", paddingLeft: 0 }}>
                Project {p.id} - {p.projectName}
              </li>
            ))}
          </ul>
        )}
        {workOrdersToShow.length > 0 && (
          <ul>
            {workOrdersToShow.map((p) => (
              <li key={p.id} style={{ listStyle: "none", paddingLeft: 0 }}>
                Work Order {p.id} - {p.description}
              </li>
            ))}
          </ul>
        )}
        {recurringToShow.length > 0 && (
          <ul>
            {recurringToShow.map((p) => (
              <li key={p.id} style={{ listStyle: "none", paddingLeft: 0 }}>
                Recurring Billing {p.id} - {p.description}
              </li>
            ))}
          </ul>
        )}
      </div>
    </>
  );
};
